import { KeycloakOnLoad } from 'keycloak-js';

export const environment = {
  production: false,
  api: 'https://snl.flusso.nl/svnl/api',
  keycloak: {
    url:  'https://login.snl.flusso.nl',
    realm: 'Svnl',
    clientId: 'portal',
    initOptions: {
      onLoad: '' as KeycloakOnLoad,
      silentCheckSsoRedirectUri: '',
      redirectUri: '',
    },
  },
  funnel : {
    url : 'https://funnel.snl.flusso.nl.nl/#!/',
  },
  cancelDisabled: true,
  analytics: {
    ga : {
      enabled: false,
      code: 'DISABLED',
    },
    gtm : {
      enabled: false,
      code : 'DISABLED',
    },
  },
};
